import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AttendanceService } from '../../../../../core/services/attendance.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import {FileService as myFileService} from '../../../../../core/utils/file-service'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../admin/layout/includes/header/header.component';

@Component({
    selector: 'app-presence-create',
    templateUrl: './presence-create.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule],
    styleUrls: ['./presence-create.component.css']
})
export class PresenceCreateComponent {
  buttonsPermission :any|undefined;
  search_text=""
  levelsFiltered:any[] =[]
  levels:any[] =[]
  cycles:any[] =[]
  attendance_categories:any[]=[]
  data:any[] =[]
  paccs:any[] =[]
  periods:any[] =[]
  courses:any[] =[]
  classrooms:any[] =[]
  selected_data:any;
  selectedCourse:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  cycleId:any
  periodId:any
  loading=false
  tag="professors-attendance-create"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  verifyCycle:any[] =[]
  classroomId:any
  pacId:any

  constructor(
    private attendanceService:AttendanceService,
    private toastrService:ToastrService,
    private sacService:StudentAyClassroomService,
    private pacServices:ProfessorAcademicClassroomService,
    private spinnerService:NgxSpinnerService,
    private pacService:ProfessorAcademicClassroomService,
    private periodServices:PeriodService,
      config: NgbModalConfig,
      private router:Router,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
    this.getPeriods()
    this.attendance_categories=this.lsService.get(GlobalName.features).attendance_categories

    this.user=this.lsService.get(GlobalName.userName)
    this.cycles=this.lsService.get(GlobalName.features).cycles
    this.verifyCycle=this.user?.professor?.cycles.filter((el:any)=> el.tag == this.cycles[0] || el.tag == this.cycles[1] || el.tag == this.cycles[2])
    console.log(this.verifyCycle)
    if (this.verifyCycle.length!=0) {
      this.professorAcademicClassroomList()
    } else {
      this.getCourses()

    }
    console.log(this.attendance_categories)
  }


  loadlist(e:any){
    console.log(e)
    this.classroomId=e.classroom?.id
    this.pacId=e.id
    this.getStudentAcademicClassroomList(e.classroom?.id)
  }

  getStudentAcademicClassroomList(classroomId:any){
    this.data=[]


    this.spinnerService.show()
    this.sacService.getAll(classroomId).subscribe((res:any)=>{
      res.data.forEach((element:any) => {
        this.data.push({
          identity:` ${element.student?.lastname} ${element.student?.firstname}`,
          type:this.attendance_categories[1],
          coming_time:null,
          motif:"",
          motif_filename:"",
          file:null,
          file64:null,
          concerned_id:element.student?.current_ay_classroom?.id
        })
      });

      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des classes apprenants",err)
    })
  }
  professorAcademicClassroomList(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes apprenants",err)
    })
  }
  
  getPeriods(){
    this.periodServices.getAll().subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }
  getCourses(){
    this.pacServices.getProfessorAcademicClassroomsCourses().subscribe((res:any)=>{
      this.paccs=res.data
      res.data.forEach((el:any) => {
        el.courses.forEach((el2:any) => {
            this.courses.push({
              id:el2.pivot?.id,
              name:el2.name,
              classroom:el.classroom?.name,
              classroomId:el.classroom_id
            })
        });
      });
      
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }


  init(){
   // this.getAll()
  
  }

  loadLevels(event:any){
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == event?.target.value)
  }

  getAll(){
    this.attendanceService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }

  setPeriod(ev:any){
    this.periodId=ev
  }

  store(){
    let data;

    if (this.verifyCycle.length!=0) {
      if (this.classroomId== undefined) {
        this.toastrService.warning('Veuillez choisir la classe')
        return ;
        }
        if (this.periodId== undefined) {
          this.toastrService.warning('Veuillez choisir une période')
          return ;
      }
       data={
        category:'Apprenant',
        period_id:this.periodId,
        pacc_id:null,
        pac_id:this.pacId,
        details:this.data
      }
    } else {
       if (this.selectedCourse== undefined) {
          this.toastrService.warning('Veuillez choisir une séance')
          return ;
      }
      if (this.periodId== undefined) {
        this.toastrService.warning('Veuillez choisir une période')
        return ;
    }
     data={
      category:'Apprenant',
      period_id:this.periodId,
      pacc_id:this.selectedCourse.id,
      details:this.data
    }
    }

     
    this.loading=true

    this.attendanceService.store(data).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.router.navigate(['/professor-module/attendances'])

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des présences",err)

    })
  }
  update(value:any){
    this.loading=true

    this.attendanceService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des présences",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.attendanceService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des présences",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.cycleId=this.levels.find((el:any)=>el.id == this.selected_data.level_id)?.cycle_id
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == this.cycleId)

  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/bvs-attendances-details/'+this.selected_data.code])
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.attendanceService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des présences",err)

      })
  }

  getPage(event:any){
    this.pg.p=event
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:true,
      add:false,
      edit:false,
      delete:true,
      status:true,
    }
  }

  loadList(ev:any){
    this.data=[]
    this.selectedCourse=this.courses[ev]
    console.log(this.selectedCourse);

      this.sacService.getAll(this.selectedCourse.classroomId).subscribe((res:any)=>{
        res.data.forEach((element:any) => {
          this.data.push({
            identity:` ${element.student?.lastname} ${element.student?.firstname}`,
            type:this.attendance_categories[1],
            coming_time:null,
            motif:"",
            motif_filename:"",
            file:null,
            file64:null,
            concerned_id:element.id
          })
        });

        console.log(this.data)
      },
    (err:any)=>{
      AppErrorShow.showError("Gestion des présences",err)

    })
    }

    getColor(type1:any,type2:any){
      let color='#E8EAED'
      if (type1==type2) {
        switch(type2){
          case 'Présent':
            color= 'green'
            break;
          case 'Absent':
            color= 'red'

            break;
          case 'Retard':
            color= 'orange'

            break;
          case 'Punition':
            color= 'red'

            break;
          case 'Exclus':
            color= 'red'

            break;
            default:
              break;
        }
      }
      

      return color;
    }

    setColor(i:any,type:any){
      this.data[i].type=type
      this.getColor(type,type)
    }


    upload(event:any,i:any){
      if(event.target.files.length!=0){
        let fileInput=event.target.files[0]
        this.addFile(fileInput,i)
        
      }
    }
    async addFile(fileInput:any,i:any){
      this.data[i].file=fileInput
        this.data[i].file64=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(fileInput))
    }
    
    removeFile(i:any){
      this.data[i].file=null
      this.data[i].file64=null
    }
}
